import { alpha, CSSObject, IconButton, styled } from '@mui/material';
import { common } from '@mui/material/colors';

import { AppLayout } from '@/dmdrive/core/constants/layout';

export const LeftSidebarRoot = styled('div')(({ layout, isOpen }: { layout: AppLayout; isOpen: boolean }) => {
  let styles: CSSObject = {
    flexShrink: 0,
    zIndex: 1000,
    backgroundColor: common.white,
  };

  if (layout === AppLayout.Desktop) {
    styles = {
      ...styles,
      position: 'relative',
      width: '20rem',
    };
  }

  if (layout === AppLayout.Mobile) {
    styles = {
      ...styles,
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: '-100%',
    };

    if (isOpen) {
      styles.left = 0;
    }
  }

  return styles;
});

export const CloseLeftSidebar = styled(IconButton)({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
});

export const LeftSidebarContent = styled('div')({
  borderRight: `0.1rem solid ${alpha(common.black, 0.12)}`,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
});

export const LeftSidebarBlock = styled('div')(({ isHeader }: { isHeader?: boolean }) => ({
  position: 'relative',
  padding: '0.5rem 1rem',
  backgroundColor: isHeader ? alpha(common.black, 0.05) : common.white,
  '&:not(:last-child)': {
    borderBottom: `0.1rem solid ${alpha(common.black, 0.12)}`,
  },
  display: isHeader ? 'flex' : 'block',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
